(function($) {

/* jshint forin:true, noarg:true, noempty:true, eqeqeq:true, bitwise:true, strict:true, undef:true, unused:true, browser:true, devel:true, jquery:true, indent:4, maxerr:50, boss:true, trailing:true, white:true, sub:true*/
/* globals  jQuery:true, TweenMax:true, window:true, navigator:true, TimelineMax:true, Spinner:true, Sector:true, generic: true, site: true*/

Drupal.behaviors.ModuleThreeMinuteBeautyBoutique = {
	attach: function(context, settings) {

		///////////////////////////////////
		// BEGIN: Utility Functions
		///////////////////////////////////
		/**
		* @function external:'jQuery.fn'.quickshop
		* @description Creates quickshop functionality for target element(s)
		* @param {Object} options - Options for quickshop function
		* @param {boolean} debug [options.debug=false] - Whether to display debug messages or not
		* @returns {jQuery} - Target elements this function was called on
		*/
		jQuery.fn.quickshop = function(options) {

			// Note: QUICKSHOP SWITCH
			// Quickshop doesn't work on dynamic.li, we put this in so we dont ever have to worry about commenting out this block again
			if (window.location.href.indexOf('dynamic.li') > -1) return;

			var $ = jQuery,
				$this = $(this),
				product_ids = [],
				defaults = {
					debug: false
				};

			options = $.extend(defaults, options);

			// Build list of product ids
			// NOTE: each quickshop <a> should have a data-productID='PROD###' where ### is the specific product ID
			// If not it will attempt to parse the product url ex url : /product/12883/6600/Product-Catalog/Makeup/Accessories/Brushes/Concealer-Brush
			$this.each(function() {
				var $this = $(this),
					product_id,
					splitPathName;

				if (typeof $this.data('product') !== 'undefined') product_id = $this.data('product');
				else {
					var pathname = this.pathname;

					if (pathname.charAt(0) !== '/') pathname = '/' + pathname;

					splitPathName = pathname.split('/');

					if(splitPathName.length >= 3) product_id = 'PROD' + splitPathName[3];
				}

				if(typeof product_id !== 'undefined' && /^(PROD\d+)$/.test(product_id)) {
					if(options.debug) console.log('quickshop: Found product id for : ', $this, ' with ' + product_id);

					product_ids.push(product_id);
				}	else if(options.debug) console.log('quickshop: Failed to find product id for : ', $this, ' with ID ' + product_id, /^(PROD\d+)$/.test(product_id));

			});

			if(options.debug) console.log('quickshop: Found products: ' + product_ids);

			// Run the fetch for all required fields for quickshop
			generic.jsonrpc.fetch({
				method: 'prodcat',
				params: [{
					products: product_ids,
					'sku_fields': [
						'HEX_VALUE_STRING',
						'INVENTORY_STATUS',
						'LARGE_IMAGE',
						'MEDIUM_IMAGE',
						'PRICE',
						'PRODUCT_ID',
						'PRODUCT_SIZE',
						'SHADENAME',
						'SKU_BASE_ID',
						'SKU_ID',
						'XL_IMAGE',
						'XL_SMOOSH',
						'formattedPrice'
					],
					product_fields: [
						'ATTRIBUTE_DESC_1',
						'ATTRIBUTE_DESC_2',
						'ATTRIBUTE_LABEL_1',
						'ATTRIBUTE_LABEL_2',
						'PRODUCT_DETAILS_MOBILE',
						'DEFAULT_CAT_ID',
						'DISPLAY_STATUS',
						'FAMILY_CODE',
						'MPP_DESC_1',
						'MPP_DESC_2',
						'PRODUCT_ID',
						'PROD_RGN_NAME',
						'PROD_RGN_SUBHEADING',
						'RATING_IMAGE',
						'SHORT_DESC',
						'TOTAL_REVIEW_COUNT',
						'priceRange',
						'shaded',
						'sized',
						'skus',
						'url'
					]
				}],
				onSuccess: function(results) {
					var product_results;

					if(typeof results === 'undefined' || typeof results.getValue() === 'undefined' || typeof results.getValue().products === 'undefined' || results.getValue().products.length === 0)
						return;

					product_results = results.getValue().products;

					if(options.debug) console.log('quickshop: Success: ', product_results);

					if(product_results.length === 0)
						return;

					// Match product ID with product data with same product ID and save as a data attribute
					$this.each(function() {
						var $this = $(this),
							product = $this.data('product'),
							productResult,
							p = 0;

						// Must have a filled product ID
						if(typeof product === 'undefined' || product.length === 0)
						{
							if(options.debug) console.log('quickshop: Failed to associate product ID: ' + product + ' data with: ', $this);
							return;
						}

						for(p = 0; p < product_results.length; p++)
						{
							productResult = product_results[p];
							if(product === productResult.PRODUCT_ID)
							{
								if(options.debug) console.log('quickshop: Successfully associated product ID: ' + product + ' data with: ', $this);
								$this.data('product_data', productResult);
								return;
							}
						}
					});

					// Event call to open quickshop
					$this.off('click').on('click', function(e) {
						var $this = $(this);

						if(options.debug) console.log('quickshop: Attemping open ' + $this + ' with ' + $this.data('product') + ' with data ' + $this.data('product_id'));

						// Do not do anything if there isn't any product_data associated with the quickshop
						if(typeof $this.data('product_data') === 'undefined')
							return;

						e.preventDefault();
						// Launch the quickshop
						site.quickshop($this.data('product_data'));
					});
				},
				onFail: function(error) {
					if(options.debug) console.log('quickshop: Error : With Error ', error);
				}
			});

			return $this;
		};

		/**
		* @function quickshop
		* @description A helper function that calls jQuery.fn.quickshop, created to replicate older quickshop functionality pre-jQuery plugin rewrite
		* @returns {jQuery} - A jQuery object containing <a> with shop_now classes found in the document
		*/
		function quickshop() {
			return jQuery('#tips_boutique a.quickshop').quickshop();
		}


		///////////////////////////////////
		// END: Utility Functions
		///////////////////////////////////

		// DOM Elements
		var $window = $(window),
			$body = $('body'),
			// debug
			debug = window.location.search.indexOf('debug=true') !== -1 ? true : false,
			// Platform checks
			isMobile = typeof site !== 'undefined' ? site.client.isMobile : (/iphone|ipod|android|blackberry|mini|windows\sce|palm/i.test(navigator.userAgent.toLowerCase())),
			isIpad = navigator.userAgent.toLowerCase().match(/ipad/i) !== null,
			mobileSize = 640;

		// set classes for desktop/mobile/ipad/ie
		if (isIpad) $body.addClass('ipad');
		else $body.addClass((isMobile ? 'mobile' : 'desktop'));

		isMobile = $(window).width() <= mobileSize;
		if(isMobile) $body.addClass('mobile');

		// Resize handler that should trigger resize handling with a delay after a resize
		var resizeHandler = _.debounce(function() {
			// Add mobile class if desktop class scales under mobile size
			if($body.hasClass('desktop')) {
				if($window.width() <= mobileSize && !$body.hasClass('mobile')) {
					$body.addClass('mobile');
					isMobile = true;
					$(window).trigger('desktopGainedMobile');
				} else if($window.width() > mobileSize && $body.hasClass('mobile')) {
					$body.removeClass('mobile');
					isMobile = false;
					$(window).trigger('desktopLostMobile');
				}
			}
		}, 500);

		// on resize update MAIN and update desktop/mobile classes
		$window.resize(resizeHandler).trigger('resize');

		// Run EL Product plugin to populate carousel
		function runELProduct(callback) {
			// strip trailing comma
			$('.el-product_id-list').text($('.el-product_id-list').text().slice(0,-1));

			$('.carousel_container').elproduct({
				'target'    : '.el-product',
				'template'  : '.hidden-products-markup-to-clone .el-product',
				'products' : '.el-product_id-list',
				'debug': false,
				onSuccess: function(){
					if(typeof callback === 'function')
						callback();
				}
			});
		}

		/////////////////////////////////////
		// BEGIN: INDEX.HTML (Homepage)
		/////////////////////////////////////
		(function() {
			var $self = $('#tmb_container'),
				$desktopSelectors = [$self.find('.mb_header'), $self.find('#tile_get-glow'), $self.find('#mb_boutique_quote-beauty'), $self.find('.mb_section-1_bg-mascara'), $self.find('.mb_section-1_bg-eye-shadow'), $self.find('#tile_fatigue-fighter'), $self.find('#tile_lip-perfector'), $self.find('#mb_boutique_quote-lips'), $self.find('#tile_brow-contouring'), $self.find('#tile_simple-smoky'), $self.find('.mb_section-1_bg-lipstick'), $self.find('#tile_ez-contouring'), $self.find('#tile_heart-blush'), $self.find('#mb_boutique_quote-makeup'), $self.find('.mb_section-1_bg-blush')],
				$mobileSelectors = [
					$self.find('.mb_header'),
					$self.find('#mb_boutique_quote-beauty'),
					$self.find('.mb_section-1_bg-mascara_mobile'),
					$self.find('#tile_get-glow'),
					$self.find('#tile_fatigue-fighter'),
					$self.find('.mb_section-1_bg-eye-shadow_mobile'),
					$self.find('#tile_lip-perfector'),
					$self.find('#tile_brow-contouring'),
					$self.find('.mb_section-1_bg-lipstick_mobile'),
					$self.find('#tile_simple-smoky'),
					$self.find('#tile_ez-contouring'),
					$self.find('.mb_section-1_bg-blush_mobile'),
					$self.find('#tile_heart-blush'),
				];
				//$desktopSelectors = [$('.mb_header'), $('#tile_get-glow'), $('#mb_boutique_quote-beauty'), $('.mb_section-1_bg-mascara'), $('.mb_section-1_bg-eye-shadow'), $('#tile_fatigue-fighter'), $('#tile_lip-perfector'), $('#mb_boutique_quote-lips'), $('#tile_brow-contouring'), $('#tile_simple-smoky'), $('.mb_section-1_bg-lipstick'), $('#tile_ez-contouring'), $('#tile_heart-blush'), $('#mb_boutique_quote-makeup'), $('.mb_section-1_bg-blush')],
				//$mobileSelectors = [$('.mb_header'), $('#tile_get-glow'), $('#mb_boutique_quote-beauty'), $('.mb_section-1_bg-mascara_mobile'), $('.mb_section-1_bg-eye-shadow_mobile'), $('#tile_fatigue-fighter'), $('#tile_lip-perfector'), $(' #mb_boutique_quote-lips'), $('#tile_brow-contouring'), $('#tile_simple-smoky'), $('.mb_section-1_bg-lipstick_mobile'), $('#tile_ez-contouring'), $('#tile_heart-blush'), $('#mb_boutique_quote-makeup'), $('.mb_section-1_bg-blush_mobile')];

			// on postload, animate in desktop or mobile selectors
			$window.on('postLoad', function() {
				// set timeout to just give the tiniest of buffers for a smoother animation
				setTimeout(function() {
					TweenMax.staggerTo(isMobile ? $mobileSelectors : $desktopSelectors, 1, {opacity : 1}, isMobile ? 0.8 : 0.5);
				}, 1024);
			});
		})();
		/////////////////////////////////////
		// END: INDEX.HTML (Homepage)
		/////////////////////////////////////

		/////////////////////////////////////
		// BEGIN: TIPS PAGES
		/////////////////////////////////////
		(function () {
			// var $self = $('#tips_boutique .mpp-carousel'),
			var $self = $('#tips_boutique'),
				// Mobile animation vars
				$currentSlide,
				// DOM
				// $selectors = [$('.tips_section .header-image'), $('.tips_section .header'), $('.tips_section .header-description'), $('.tips_section .step'), $('.tips_section .mpp-carousel')],
				$selectors =  isMobile ? [
					$self.find('.tips_section .header'),
					$self.find('.tips_section .header-description'),
					$self.find('.tips_section .header-image'),
					$self.find('.tips_section .step'),
					$self.find('.tips_section .mpp-carousel')
				] : [
					$self.find('.tips_section .header-image'),
					$self.find('.tips_section .header'),
					$self.find('.tips_section .header-description'),
					$self.find('.tips_section .step'),
					$self.find('.tips_section .mpp-carousel')
				],
				$carousel = $self.find('.carousel'),
				$arrowLeft = $self.find('.carousel_pagers .arrow.left'),
				$arrowRight = $self.find('.carousel_pagers .arrow.right');

			// run EL Product
			var modeEvaluation = (function() {
				if(isMobile === false)
					setDesktopMode();
				else
					setMobileMode();

				// Set desktop/mobile functionality event handling here so that it won't interfere with carousel scripts
				$window
				.on('desktopGainedMobile', setMobileMode())
				.on('desktopLostMobile', setDesktopMode());
			});

			runELProduct(modeEvaluation);

			/**
			* @function setMobileMode
			* @description Clears events used for desktop
			* @returns {undefined} this function does not return anything
			*/
			function setMobileMode() {
				$carousel = $('#tips_boutique .carousel');

				if($carousel.length === 0 || typeof jQuery.fn.el_carousel === 'undefined') return;

				$currentSlide = $();

				// Enable carousel
				$carousel.carouselSetEnabled(true);
				$carousel.carouselUpdate();
				$carousel.carouselDestroy();
				$carousel.el_carousel({
					useGSAP: true,
					offset: '3%',
					increment: '50%',
					duration: 0.5,
					debug: debug
				});

				$window.on('resize', $carousel.carouselUpdate);

				// Carousel controls
				$arrowLeft.on('click', function (e) {
					e.preventDefault();
					$carousel.carouselPrev();
				});

				$arrowRight.on('click', function(e) {
					e.preventDefault();
					$carousel.carouselNext();
				});

				$self.swipe('enable');

			}

			/**
			* @function setDesktopMode
			* @description Creates events needed for desktop functionality
			* @returns {undefined} This function doesn't return anything
			*/
			function setDesktopMode() {
				$carousel = $('#tips_boutique .carousel');

				if($carousel.length === 0 || typeof jQuery.fn.el_carousel === 'undefined') return;

				$currentSlide = $();

				// Enable carousel
				$carousel.carouselSetEnabled(true);
				$carousel.carouselUpdate();
				$carousel.carouselDestroy();
				$carousel.el_carousel({
					useGSAP: true,
					offset: '0%',
					increment: '38.5%',
					duration: 0.5,
					debug: debug
				});

				$window.on('resize', $carousel.carouselUpdate);

				// Carousel controls
				$arrowLeft.on('click', function (e) {
					e.preventDefault();
					$carousel.carouselPrev();
				});

				$arrowRight.on('click', function(e) {
					e.preventDefault();
					$carousel.carouselNext();
				});

				$window.on('keydown', function(e) {
					e.preventDefault();

					switch(e.which) {
						// Left arrow
						case 37:
							$carousel.carouselPrev();
							break;
						// Right arrow
						case 39:
							$carousel.carouselNext();
							break;
					}
				});
				$self.swipe('enable');
				
				// BEGIN: Process elements for SKU
				(function() {
					var $products = $('.carousel').find('.el-product'),
						customMPP,
						productsData;

					// Make sure page_data is not undefined
					// Continue doing this for proceeding properties until products array is hit
					if(typeof page_data !== 'undefined') {
						customMPP = page_data['custom-mpp'];
						if(typeof customMPP !== 'undefined') productsData = customMPP['products'];
					}

					// Assign classes to products found in each category
					$products.each(function(){
						var $this = $(this),
							productID = $this.data('product'),
							p = 0,
							productData,
							skus,
							skuData;

						if(debug) console.log('Found product with ID ' + productID, $this);

						// Assign SKUs per product based on page_data values (if it exists)
						// ... And is an Array
						if(typeof productsData !== 'undefined' && productsData instanceof Array) {
							for(p = 0; p < productsData.length; p++)
							{
								productData = productsData[p];
								if(typeof productData['PRODUCT_ID'] !== 'undefined' && productData['PRODUCT_ID'] === productID) {
									skus = productData['skus'];
									if(typeof skus !== 'undefined' && skus instanceof Array){
										// Use first sku data
										skuData = skus[0];

										if(typeof skuData['SKU_ID'] !== 'undefined') {
											$this.attr('data-sku', skuData['SKU_ID']);
											break;
										}
									}
								}

							}
						}
					});
				})();
				// END: Process elements for SKU
				
			}

			events: {
				// singular product quickshop/add to bag
				$self.find('.el-product_shop-now.quickshop').on('click', function(e){
					e.preventDefault();
					var $this = $(this);

					// if shop button is tied to add-to-bag run addToCart, else do quickshop
					if ($this.hasClass('add-to-bag')) {
						// add the item to the cart
						site.addToCart({
							skuData : {
								SKU_BASE_ID : $this.attr('data-sku').substr(3),
								PARENT_CAT_ID : $this.attr('data-product')
							},
							quantity : 1,
							QTY : 1
						});
					} else {
						site.quickshop($this.data('full_product_json'));
					}
				});
				
				$(document).on('addToCart.success', function() {
					$window.trigger('addAllToBag.success');
				}).on('addToCart.failure', function() {
					$window.trigger('addAllToBag.failure');
				});
				
				// add all to bag
				$self.find('.el-product_shop-now.add-to-bag').on('click', function(e) {
					e.preventDefault();

					// Get all products in the carousel
					var $products = $carousel.find('.el-product');
					var	productData;
					var	productsToLoad = [];
					// var productLoadInterval;
					var	productID;
					var	skuID;

					// iterate through found products, collect their prod ID and sku ID attributes.
					// use those attributes for addToCart call
					$products.each(function() {
						var $this = $(this);

						productID = $this.data('product');
						productID = typeof productID === 'undefined' ? '' : productID;

						skuID = $this.attr('data-sku');
						skuID = typeof skuID === 'undefined' ? '' : skuID.substr(3);
											
						productsToLoad.push({
							productID: productID,
							skuID: skuID
						});

					});
										
					if (debug) console.log('************');
					if (debug) console.log($products);
					if (debug) console.log(productsToLoad);

					// Start loading products
					if(productsToLoad.length !== 0)
					{
						productData = productsToLoad.pop();
						site.addToCart({
							skuData : {
								SKU_BASE_ID : productData.skuID,
								PARENT_CAT_ID : productData.productID
							},
							quantity : 1,
							QTY : 1
						});
						
						// Add next products to bag on either success or failure							
						$(window).off('addAllToBag.success addAllToBag.failure').on('addAllToBag.success addAllToBag.failure', function() {
							
							productData = productsToLoad.pop();
							
							if(typeof productData !== 'undefined') {
			
								site.addToCart({
									skuData : {
										SKU_BASE_ID: productData.skuID,
										PARENT_CAT_ID: productData.productID
									},
									quantity : 1,
									QTY : 1
								});
							}
							
							// No more products to add, clean up until next time
							if(typeof productData === 'undefined' || productData.length === 0)
								$(document).off('addAllToBag.success addAllToBag.failure');
						});
						
						/*
						// Load products over an interval
						productLoadInterval = window.setInterval(function() {
							productData = productsToLoad.pop();

							site.addToCart({
								skuData : {
									SKU_BASE_ID : productData.skuID,
									PARENT_CAT_ID : productData.productID
								},
								quantity : 1,
								QTY : 1
							});

							if(productsToLoad.length === 0)
								window.clearInterval(productLoadInterval);
						}, 2000);
						*/
					}
				});

				// Swipe events, this will be enabled/disabled via setDesktopMode/setMobileMode
				if(typeof jQuery.fn.swipe !== 'undefined') {
					$self.swipe({
						swipeLeft: function() {
							$carousel.carouselNext();
						},
						swipeRight: function() {
							$carousel.carouselPrev();
						},
						allowPageScroll: 'vertical',
						preventDefaultEvents: false
					});

				}

				// Enable or disable desktop/mobile functionality
				// if(!isMobile) setDesktopMode();
				// else setMobileMode();

				// Events to trigger desktop/mobile functionality
				$window
				.on('postLoad', function() {
					TweenMax.staggerTo($selectors, 1, {opacity : 1}, 0.35);
				});
			}
		})();
		/////////////////////////////////////
		// END: TIPS PAGES
		/////////////////////////////////////

		/////////////////////////////////////
		// Preloader Module
		/////////////////////////////////////
		(function() {
			var $loader = $body.find('#loader'),
				preloadTargets = [],
				spinnerOptions = {
					lines: 17, // The number of lines to draw
					length: 0, // The length of each line
					width: 5, // The line thickness
					radius: 26, // The radius of the inner circle
					scale: 1, // Scales overall size of the spinner
					corners: 1, // Corner roundness (0..1)
					color: '#999', // #rgb or #rrggbb or array of colors
					opacity: 0.5, // Opacity of the lines
					rotate: 0, // The rotation offset
					direction: 1, // 1: clockwise, -1: counterclockwise
					speed: 1, // Rounds per second
					trail: 30, // Afterglow percentage
					zIndex: 2e9, // The z-index (defaults to 2000000000)
					className: 'spinner', // The CSS class to assign to the spinner
					top: '50%', // Top position relative to parent
					left: '50%', // Left position relative to parent
					shadow: false, // Whether to render a shadow
					hwaccel: true, // Whether to use hardware acceleration
					position: 'absolute' // Element positioning
				},
				spinner = new Spinner(spinnerOptions).spin($loader[0]);

			/**
			* @function preloadHandler
			* @description Handles preload completion
			* @returns {undefined} This function doesn't return anything
			*/
			function preloadHandler() {
				// Ensure the rest of the images have been swapped in
				$body.find('img, .preload').each(function() {
					var $this = $(this),
						dataSrc = $this.data('src');

					if(typeof dataSrc !== 'undefined')
						$this.attr('src', dataSrc);
				});

				// Delay used to ensure enough images are loaded before displaying site
				TweenMax.to($loader, 1, {opacity: 0, display: 'none', delay: 1, onComplete: function(){
					spinner.stop();
					$window.trigger('scroll');
					$window.trigger('postLoad');

					runELProduct();
				}});
			}

			/**
			* @function triggerPreload
			* @description Helper function for preload
			* @returns {undefined} This function doesn't return anything
			*/
			function triggerPreload() {

				if(debug) console.log('triggerPreload: Preload Triggered');

				$(preloadTargets).FreeLoader({
					debug: debug,
					callback: preloadHandler
				});
			}

			// Deeplink'd section gets priority over all other sections
			$body.find('.tips_section').each(function(){
				var $preloadTarget = $(this).find('img, .preload').not(isMobile ? '.desktop' : '.mobile');

				if(typeof $preloadTarget.data('src') !== 'undefined') preloadTargets.push($preloadTarget);
			});

			if(preloadTargets.length === 0) preloadHandler();
			else triggerPreload();

			if(typeof $deeplinkSection !== 'undefined' && $deeplinkSection.length !== 0) deeplinkMethods.deeplinking = true;
		})();
		/////////////////////////////////////
		// Preloader Module
		/////////////////////////////////////
	}
};

})(jQuery);
